import { render, staticRenderFns } from "./MovimentacaoExterna.vue?vue&type=template&id=19bacca2&scoped=true&"
import script from "./MovimentacaoExterna.vue?vue&type=script&lang=js&"
export * from "./MovimentacaoExterna.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacaoExterna.vue?vue&type=style&index=0&id=19bacca2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bacca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VFlex,VTab,VTabItem,VTabs,VTabsItems})
